import { Extension } from '@tiptap/core';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import type { EditorState } from '@tiptap/pm/state';
import { Plugin, PluginKey } from '@tiptap/pm/state';

interface SelectionRange {
  from: number;
  to: number;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    selectionHighlight: {
      clearSelection: () => ReturnType;
    };
  }
}

export const SelectionHighlightCommands = Extension.create({
  name: 'selectionHighlightCommands',

  addCommands() {
    return {
      clearSelection: () => {
        return ({ tr, dispatch, editor }) => {
          if (editor.storage?.selectionHighlight?.selection) {
            editor.storage.selectionHighlight.selection = null;
            if (dispatch) {
              dispatch(tr);
            }
            return true;
          }
          return false;
        };
      },
    };
  },
});

export const SelectionHighlight = Extension.create({
  name: 'selectionHighlight',

  addStorage() {
    return {
      selection: null as SelectionRange | null,
    };
  },

  addProseMirrorPlugins() {
    const pluginKey = new PluginKey('selectionHighlight');
    const storage = this.storage;

    return [
      new Plugin({
        key: pluginKey,
        onTransaction: ({ transaction }) => {
          const { empty, from, to } = transaction.selection;

          if (!empty && from !== to) {
            storage.selection = { from, to };
          } else {
            storage.selection = null;
          }
        },
        props: {
          decorations: (state: EditorState) => {
            const { empty, from, to } = state.selection;

            if (!empty && from !== to) {
              storage.selection = { from, to };
              return DecorationSet.create(state.doc, [
                Decoration.inline(from, to, {
                  class: 'selection-highlight',
                }),
              ]);
            }

            storage.selection = null;
            return DecorationSet.empty;
          },
        },
      }),
    ];
  },
});
